import { createTheme } from "@mui/material";
export const theme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        groupLabel: {
          fontSize: ".625rem",
          color: "#8792AB",
          textTransform: "uppercase",
          paddingTop: "10px",
          paddingBottom: "10px",
          paddingLeft: "5px",
          lineHeight: "11px",
          background: "#ffffff",
        },
        groupUl: {
          "& .MuiAutocomplete-option": {
            paddingLeft: "0px",
          },
        },
        option: {
          paddingLeft: "0px",
          color: "#050D2E",
          fontSize: ".875rem",
          background: "#ffffff",
        },
        listbox: {
          paddingTop: "0px",
          padding: "0px",
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: "0px",
        },
      },
    },
  },
});
